export const REGULATED_PRODUCT_TTL_ES = 'Productos Regulados';
export interface IRegulatedProductBase {
  code: number;
  name: string;
  barCode: string;
  concentration: string;
  form: string;
  formSimp: string;
  presentation: string;
  laboratory: string;
  fractions: number;
  format: { name: string };
  condition: string;
  conditionCode: string;
}

export interface IRegulatedProduct extends IRegulatedProductBase {
  id: number;
  tagStatusColor: string;
}

export interface IHierarchyFormat {
  id: number;
  nombre: string;
  subFormat: string;
  cantidad: number;
  FV: boolean;
  FMV: boolean;
}
export interface ICustomizedFormat {
  id: number;
  nombre: string;
  subFormat: string;
  cantidad: number;
}

export interface IHierarchyFormatUpdate {
  id: number;
  nombre: string;
  subFormat: string;
  quantitySubFormat: number;
  FV: boolean;
  FMV: boolean;
}
export interface ICustomizedFormatUpdate {
  id: number;
  nombre: string;
  subFormat: string;
  quantitySubFormat: number;
}
